import { Deal } from "@Types/deal";
import {
  formatCollateral,
  formatCustomersNames,
} from "@Pages/Applications/Applications";
import { formatDate } from "@Utils/functions";

import styles from "./SelectLoan.module.scss";

const SelectedLoan = ({ deal }: { deal?: Deal }) => {
  if (!deal) return <></>;
  return (
    <div className={styles.selectedLoan}>
      <div className={styles.selectedLoanRow}>
        <div className={styles.headerText}>Applicant</div>
        <div className={styles.headerText}>Collateral</div>

        <div className={styles.headerText}>F&I Manager</div>
        <div className={styles.headerText}>Date Added</div>
      </div>
      <div className={styles.selectedLoanRow}>
        <div className={styles.rowText}>{formatCustomersNames(deal)}</div>
        <div className={styles.rowText}>{formatCollateral(deal)}</div>
        <div className={styles.rowText}>
          {deal?.data?.user?.data?.info?.firstName
            ? `${deal?.data?.user?.data?.info?.firstName ?? ""} ${
                deal?.data?.user?.data?.info?.lastName ?? ""
              } `
            : "N/A"}
        </div>
        <div className={styles.rowText}>{formatDate(deal?.createdAt)}</div>
      </div>
    </div>
  );
};
export default SelectedLoan;
